import React from "react";
import { Container, Card, Row, Col } from "react-bootstrap";
import NestedPageHero from "./NestedPageHero";

const PoloPage = () => {
  return (
    <div>
      <NestedPageHero title={"Polo"} />
      <Container className="my-5">
        <h1 className="text-center text-warning mb-4">Polo Living Spaces</h1>
        <Row>
          <Col md={6}>
            <Card className="border-0 shadow">
              <Card.Img variant="top" src="/images/1.webp" height={300}/>
              <Card.Body>
                <Card.Title>Modern Design</Card.Title>
                <Card.Text>
                  Minimalistic interiors for a clean and sleek look.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="border-0 shadow">
              <Card.Img variant="top" src="/images/3.webp" height={300} />
              <Card.Body>
                <Card.Title>Premium Amenities</Card.Title>
                <Card.Text>
                  Enjoy features like private balconies and large windows.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PoloPage;
